export const links = [
    {
        "nombre" : "Transparencia",
        "link" : "/Paginas/Transparencia",
        "submenu" : [
            {
                "subMenuNombre" : "48 Rubros",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
            {
                "subMenuNombre" : "Rubros Anteriores",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            },
            {
                "subMenuNombre" : "Armonización Contable",
                "subMenuUrl" : "/Pag/armonizacion"
            },
            {
                "subMenuNombre" : "Art. 70 Ley de Transparencia",
                "subMenuUrl" : "/Pag/art70"
            },
            {
                "subMenuNombre" : "Descarga Información Financiera SRFT",
                "subMenuUrl" : "/Pag/informacionfinanciera"
            },
            {
                "subMenuNombre" : "Ligas de Interés",
                "subMenuUrl" : "/Pag/ligas"
            }, 
            {
                "subMenuNombre" : "CEPCI",
                "subMenuUrl" : "/Pag/cepci"
            }, 
            {
                "subMenuNombre" : "COCODI",
                "subMenuUrl" : "/Pag/cocodi"
            }, 
            {
                "subMenuNombre" : "Diagnóstico Séptimo Transitorio",
                "subMenuUrl" : "/Pag/septimo"
            },
            {
                "subMenuNombre" : "Programa Anual de Adquisiciones",
                "subMenuUrl" : "/Pag/paaas"
            }
        ]
    },
    {
        "nombre" : "Servicios",
        "link" : "/Paginas/Servicios",
        "submenu" : [
            {
                "subMenuNombre" : "Licencia de Conducir",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/10614"
            },
            {
                "subMenuNombre" : "Permiso a menores",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/1288"
            },
            {
                "subMenuNombre" : "Denuncia Anónima",
                "subMenuUrl" : "https://denuncia089.hidalgo.gob.mx/"
            },
            {
                "subMenuNombre" : "Convocatoria Instituto de Formación Profesional",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/6717"
            },
            {
                "subMenuNombre" : "Policía Cibernética de Hidalgo",
                "subMenuUrl" : "https://policiacibernetica.hidalgo.gob.mx/"
            },
            {
                "subMenuNombre" : "Policía Industrial Bancaria",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/927"
            },
            {
                "subMenuNombre" : "Contigo Contra la Violencia y la Delincuencia",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/925"
            },
            {
                "subMenuNombre" : "Directorio de CERESO",
                "subMenuUrl" : "/Ceresos"
            },
            {
                "subMenuNombre" : "Código H",
                "subMenuUrl" : "../assets/imgs/Codigo-H.png"
            },
            {
                "subMenuNombre" : "Seguridad Privada",
                "subMenuUrl" : "/Privada"
            },
            {
                "subMenuNombre" : "Verificación de unidades GAS LP",
                "subMenuUrl" : "http://verificacionunidadesgaslp.hidalgo.gob.mx/"
            },
            {
                "subMenuNombre" : "Información Financiera SRFT",
                "subMenuUrl" : "/Pag/srft"
            }
            
            
        ]
     

    },
    {
        "nombre" : "Dependencias",
        "link" : "/Paginas/Dependencias",
        "submenu" : [
            {
                "subMenuNombre" : "C5i",
                "subMenuUrl" : "/Pag/c5i"
            },
            {
                "subMenuNombre" : "IFP",
                "subMenuUrl" : "/Pag/IFP"
            }
        ]
    }



]